<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DraggableComponent extends Vue {
  private positions = {
    clientX: undefined,
    clientY: undefined,
    movementX: 0,
    movementY: 0
  };

  private widthToSpare: number = 60;
  private heightToSpare: number = 50;
  private dragMouseDown(event: any) {
    event.preventDefault();

    // get the mouse cursor position at startup:

    this.positions.clientX = event.clientX;
    this.positions.clientY = event.clientY;
    document.onmousemove = this.elementDrag;
    document.onmouseup = this.closeDragElement;
  }

  private elementDrag(event: any) {
    event = event || window.event;
    event.preventDefault();
    const cursorOutsidetheScreenHorizontally: boolean = event.clientX > window.innerWidth - this.widthToSpare || event.clientX < this.widthToSpare;
    const cursorOutsidetheScreenVertically: boolean = event.clientY > window.innerHeight - this.heightToSpare || event.clientY < this.heightToSpare;

    this.positions.movementX = cursorOutsidetheScreenHorizontally ? 0 : this.positions.clientX! - event.clientX;
    this.positions.movementY = cursorOutsidetheScreenVertically ? 0 : this.positions.clientY! - event.clientY;

    this.positions.clientX = event.clientX;
    this.positions.clientY = event.clientY;
    // set the element's new position:
    const container = this.$refs.draggableContainer as any;
    container.style.top = container.offsetTop - this.positions.movementY + 'px';
    container.style.left = container.offsetLeft - this.positions.movementX + 'px';
  }

  closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  }

  resetDraggablePosition(event: any) {
    const container = this.$refs.draggableContainer as any;
    container.style.left = 1 + 'vw';
    container.style.bottom = 1 + 'vh';
  }

  created() {
    window.addEventListener('resize', this.resetDraggablePosition);
  }

  destroyed() {
    window.removeEventListener('resize', this.resetDraggablePosition);
  }
}
</script>

<style>
</style>
